<template>
  <div>
    <v-card
      v-for="(item, index) in items"
      :key="`item-${index}-${item.name}`"
      class="item-card mb-4"
      elevation="3"
    >
      <!-- Header Section -->
      <div class="card-header">
        <div class="item-name">{{ item.name }}</div>
        <v-btn
          icon
          small
          color="error"
          class="delete-btn"
          @click="deleteItem(items, index)"
        >
          <v-icon size="20">mdi-delete</v-icon>
        </v-btn>
      </div>

      <v-divider class="my-3"></v-divider>

      <!-- Content Section -->
      <v-row class="item-content" align="center" no-gutters>
        <!-- Quantity -->
        <v-col :cols="isMobile ? 12 : 4" class="mb-3 mb-md-0">
          <div class="input-group">
            <label class="input-label">Quantity</label>
            <input
              type="number"
              :id="`quantity-${index}`"
              class="custom-input"
              min="1"
              :value="item.quantity"
              @blur="changeQuantity(index, item, $event)"
              @input="handleQuantityInput(index, item, $event)"
            />
          </div>
        </v-col>

        <!-- Price -->
        <v-col :cols="isMobile ? 12 : 4" class="mb-3 mb-md-0">
          <div class="input-group">
            <label class="input-label">Price</label>
            <div class="price-input-wrapper">
              <span class="currency-symbol">{{ getCurrency }}</span>
              <input
                type="text"
                :id="`price-${index}`"
                class="custom-input price-input"
                :value="item.price"
                @blur="changeCost(index, item, $event)"
                @input="handlePriceInput(index, item, $event)"
              />
            </div>
          </div>
        </v-col>

        <!-- Line Total -->
        <v-col :cols="isMobile ? 12 : 4">
          <div class="input-group">
            <label class="input-label">Total</label>
            <div class="line-total">
              {{ getCurrency }}{{ formatMoney(item.lineTotal) }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";

export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
  },

  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
  },

  methods: {
    formatMoney(amount) {
      return helpersJs.formatMoney(amount);
    },

    changeCost(index, item, event) {
      const value = event.target.value;
      item.price = helpersJs.stripNonDigitsAndCommasFromMoney(value);
      this.$emit("update-line-total", item);
    },

    handlePriceInput(index, item, event) {
      // Optional: Real-time validation or formatting
    },

    changeQuantity(index, item, event) {
      const value = event.target.value;
      item.quantity = helpersJs.stripNonDigitsAndCommasFromMoney(value);
      this.$emit("update-line-total", item);
    },

    handleQuantityInput(index, item, event) {
      // Optional: Real-time validation
    },

    deleteItem(items, index) {
      this.$emit("remove-item", [items, index]);
    },

    stripNonDigitsAndCommasFromMoney(amount) {
      return helpersJs.stripNonDigitsAndCommasFromMoney(amount);
    },
  },
};
</script>

<style scoped>
.item-card {
  border-radius: 12px;
  padding: 5px;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
  background: #ffffff;
}

.item-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
}

.item-name {
  font-size: 18px;
  font-weight: 600;
  color: #00897b;
  flex: 1;
  line-height: 1.4;
}

.delete-btn {
  flex-shrink: 0;
  margin-left: 12px;
}

.item-content {
  padding: 0 4px;
}

.input-group {
  display: flex;
  flex-direction: column;
  padding: 0 8px;
}

.input-label {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.custom-input {
  width: 100%;
  padding: 10px 12px;
  font-size: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  transition: all 0.2s ease;
  font-family: inherit;
}

.custom-input:focus {
  outline: none;
  border-color: #00897b;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(0, 137, 123, 0.1);
}

.custom-input:hover {
  border-color: #bdbdbd;
}

.price-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.currency-symbol {
  position: absolute;
  left: 12px;
  font-size: 15px;
  color: #666;
  font-weight: 500;
  pointer-events: none;
  z-index: 1;
}

.price-input {
  padding-left: 28px;
}

.line-total {
  padding: 10px 12px;
  font-size: 16px;
  font-weight: 600;
  color: #00897b;
  background: #e0f2f1;
  border-radius: 8px;
  text-align: left;
}

/* Mobile Styles */
@media (max-width: 960px) {
  .item-card {
    padding: 6px;
  }

  .item-name {
    font-size: 16px;
  }

  .custom-input {
    padding: 8px 10px;
    font-size: 14px;
  }

  .line-total {
    padding: 8px 10px;
    font-size: 15px;
    text-align: center;
  }

  .currency-symbol {
    left: 10px;
  }

  .price-input {
    padding-left: 24px;
  }

  .input-group {
    padding: 0 4px;
  }
}

/* Remove number input spinners */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
